/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    Button,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import { useNavigate } from "react-router-dom";

const Adminsignin = () => {
    const [email, setEmail] = useState("admin@admin.com");
    const [password, setPassword] = useState("admin");
    const [loading, setLoading] = useState(false);
    const history = useNavigate();

    const loginAuth = async (event) => {
        event.preventDefault();
        setLoading(true);
        if (email !== "" && password !== "") {
            try {
                const response = await fetch(`${process.env.REACT_APP_PUBLIC_SERVER}/api/login`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email, password }),
                });
                if (response.ok) {
                    const data = await response.json();
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("userType", data.type);
                    history(`${process.env.REACT_APP_PUBLIC_URL}/dashboard/admin`);
                } else {
                    const errorData = await response.json();
                    toast.error(errorData.message || "Credenciales inválidas");
                }
            } catch (error) {
                console.error(error);
                toast.error("Error al iniciar sesión");
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("Por favor, ingresa email y contraseña");
            setLoading(false);
        }
    };

    return (
        <div className='page-wrapper'>
            <Container fluid={true} className='p-0'>
                <div className='authentication-main m-0 only-login'>
                    <Row>
                        <Col md='12'>
                            <div className='auth-innerright'>
                                <div className='authentication-box'>
                                    <CardBody className='d-flex h-100'>
                                        <div className='cont text-center b-light'>
                                            <div>
                                                <Form className='theme-form' onSubmit={loginAuth}>
                                                    <h4>Inicio de Sesión</h4>
                                                    <h6>Nombre de Usuario y Contraseña</h6>
                                                    <FormGroup>
                                                        <Label className='col-form-label pt-0'>Tu Nombre</Label>
                                                        <Input
                                                            className='form-control'
                                                            type='email'
                                                            name='email'
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            placeholder='Email address'
                                                        />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label className='col-form-label'>Contraseña</Label>
                                                        <Input
                                                            className='form-control'
                                                            type='password'
                                                            name='password'
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                        />
                                                    </FormGroup>
                                                    <div className='checkbox p-0'>
                                                        <Input id='checkbox1' type='checkbox' />
                                                    </div>
                                                    <FormGroup className='d-flex flex-wrap mt-3 mb-0'>
                                                        <Button
                                                            color='primary'
                                                            className='d-block w-100'
                                                            type='submit'
                                                            disabled={loading}
                                                        >
                                                            {loading ? "Iniciando..." : "Iniciar Sesión"}
                                                        </Button>
                                                    </FormGroup>
                                                </Form>
                                            </div>
                                        </div>
                                    </CardBody>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <ToastContainer />
            </Container>
        </div>
    );
};

export default Adminsignin;